<template>
    <div class="modal-card pop_min" id="draggable" style="overflow-y:hidden">
        <header class="modal-card-head pop-header">
            <p class="modal-card-title tit">
                {{ title }}
                <button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button>
            </p>
        </header>
        <section class="modal-card-body pop-content">
            <div class="inner-box">
                <div class="table-b" style="margin-bottom: 10px">
                    <div>
                        <div v-if="hiddenCheck != 'Y'" class="btn-wrap btn-type1 clearfix">
                            <button class="btn-size btn-blue fl_right" @click="save">
                                <span class="btn-icon"><i class="fas fa-check"></i></span> 저장
                            </button>
                        </div>
                        <div v-else class="btn-wrap btn-type1 clearfix">
                            <button class="btn-size btn-gray fl_right" style="margin-left: 5px;" @click="cancel">
                                <span class="btn-icon"><i class="fas fa-check"></i></span> 삭제
                            </button>
                            <button class="btn-size btn-blue fl_right" @click="save">
                                <span class="btn-icon"><i class="fas fa-check"></i></span> 저장
                            </button>
                        </div>
                    </div>
                    <div class="inner-box" style="height: 210px">
                        <div class="table-area">
                            <div class="table-a">
                                <table id="basic" class="table">
                                    <colgroup>
                                        <col width="15%">
                                        <col width="35%">
                                        <col width="15%">
                                        <col width="35%">
                                    </colgroup>
                                    <tbody>
                                    <tr>
                                        <th class="tp-a">문서유형</th>
                                        <td>
                                            <div v-if="hiddenCheck !== 'Y'" class="td-s-thumb search-area" style="width: 200px">
                                                <b-select class="select is-fullwidth" v-model="form.docTypeCd">
                                                    <option value=''>==선택==</option>
                                                    <option
                                                            v-for="item in docTypes"
                                                            :key="item.key"
                                                            :value="item.key"
                                                            v-text="item.value"/>
                                                </b-select>
                                            </div>
                                            <div v-else class="td-s-thumb search-area" style="width: 200px">
                                                {{this.form.docTypeNm}}
                                            </div>
                                        </td>
                                        <th class="tp-a">사용여부</th>
                                        <td>
                                            <div class="td-s-thumb search-area" style="width: 100px; float: left">
                                                <b-select v-model="form.useYn">
                                                    <option value=''>==선택==</option>
                                                    <option value='Y'>사용</option>
                                                    <option value='N'>미사용</option>
                                                </b-select>
                                            </div>
                                            <div v-if="hiddenCheck == 'Y'" style="float: left; padding-top: 4px">
                                                규정순번 : {{this.form.ruleSeq}}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th class="tp-a">결재유형</th>
                                        <td>
                                            <div class="td-s-thumb search-area" style="width: 200px">
                                                <b-select class="select is-fullwidth" v-model="form.apprTypeCd">
                                                    <option value=''>==선택==</option>
                                                    <option
                                                            v-for="item in apprTypes"
                                                            :key="item.key"
                                                            :value="item.key"
                                                            v-text="item.value"/>
                                                </b-select>
                                            </div>
                                        </td>
                                        <th class="tp-a">고정여부</th>
                                        <td>
                                            <div class="td-s-thumb search-area" style="width: 200px">
                                                <b-select class="select is-fullwidth" v-model="form.fixYn">
                                                    <option value=''>==선택==</option>
                                                    <option value='Y'>고정</option>
                                                    <option value='N'>비고정</option>
                                                </b-select>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th class="tp-a">결재자구분</th>
                                        <td>
                                            <div class="td-s-thumb search-area" style="width: 200px">
                                                <b-select class="select is-fullwidth" v-model="form.aprverClassCd">
                                                    <option value=''>==선택==</option>
                                                    <option
                                                            v-for="item in aprverClassTypes"
                                                            :key="item.key"
                                                            :value="item.key"
                                                            v-text="item.value"/>
                                                </b-select>
                                            </div>
                                        </td>
                                        <th class="tp-c">결재자구분값</th>
                                        <td>
                                            <div class="td-s-thumb search-area" style="width: 200px">
                                                <input class="input" type="text" v-model="form.aprverClassVal"/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th class="tp-c">비고</th>
                                        <td colspan="3">
                                            <div class="td-s-thumb search-area" style="width: auto">
                                                <input class="input" type="text" v-model="form.remark"/>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </div>
</template>

<script>
    import Layout from '@/components/ModalSlot.vue';
    import mixin from '@/mixin';
    import mixinSlip from '@/mixin/slip';

    export default {
        name: 'ApprRulePop',
        props: ['docTypeNm',
            'docTypeCd',
            'useYn',
            'ruleSeq',
            'apprTypeNm',
            'apprTypeCd',
            'fixYn',
            'aprverClassNm',
            'aprverClassVal',
            'aprverClassCd',
            'remark',
            'hiddenCheck'],
        mixins: [mixin, mixinSlip],
        components: {Layout},
        data() {
            return {
                title: '규정 관리',
                docTypes: [],
                slipTypes: [],
                brwTypes: [],
                curTypes: [],
                apprTypes: [],
                aprverClassTypes: [],
                form: {
                    docTypeNm: '',
                    docTypeCd: 'SHORT',
                    useYn: 'Y',
                    ruleSeq: '',
                    apprTypeNm: '',
                    apprTypeCd: '20',
                    fixYn: 'Y',
                    aprverClassNm: '',
                    aprverClassVal: '',
                    aprverClassCd: '',
                    remark: '',
                },
                returnObject: {},
                showEmpModal1: false,
                showEmpModal2: false,
            }
        },
        methods:
            {
                getDocTypeCombo() {
                    this.$http.get(`/api/code/combo`, {params: {groupCd: "VISIT_TYPE_CD"}})
                        .then(response => {
                            this.docTypes = response.data;
                        });
                },
                getApprTypeCombo() {
                    this.$http.get(`/api/code/combo`, {params: {groupCd: "APPR_TYPE_CD", remark1: "Y"}})
                        .then(response => {
                            this.apprTypes = response.data;
                        });
                },
                geAprverClassTypeCombo() {
                    this.$http.get(`/api/code/combo`, {params: {groupCd: "APRVER_CLASS_CD"}})
                        .then(response => {
                            this.aprverClassTypes = response.data;
                        });
                },
                save() {
                    if (!this.validation()) return;
                    this.$swal({
                        type: 'warning',
                        text: `전결규정을 저장합니다. 계속 하시겠습니까?`,
                        showCancelButton: true,
                        confirmButtonText: '예',
                        cancelButtonText: '아니오',
                    }).then((result) => {
                        if (result.value) {
                            const param = JSON.parse(JSON.stringify(this.form));
                            const stripFields = ['maxAmt'];
                            _.forEach(stripFields, (name) => param[name] = this.toPure(param[name]));

                            //if(!this.validation(param)) return;

                            this.$http.post(`/api/appr/rule`, [param
                            ]).then((response) => {
                                this.doReturnObject(1);
                            }).catch((e) => {
                                console.error(e);
                            }).finally(()=>{
                            });
                            this.$emit('close', this.returnObject)
                            this.$parent.close();
                        }
                    })
                },
                cancel() {
                    this.$swal({
                        type: 'warning',
                        text: `전결규정을 삭제합니다. 계속 하시겠습니까?`,
                        showCancelButton: true,
                        confirmButtonText: '예',
                        cancelButtonText: '아니오',
                    }).then((result) => {
                        if (result.value) {
                            const param = JSON.parse(JSON.stringify(this.form));

                            this.$http.post(`/api/appr/deleteRules`, [param
                            ]).then((response) => {
                                this.doReturnObject(1);
                            }).catch((e) => {
                                console.error(e);
                            });
                        }
                    });
                },
                validation() {
                    const ruleInfo = JSON.parse(JSON.stringify(this.form));
                    const stripFields = ['maxAmt'];
                    _.forEach(stripFields, (name) => ruleInfo[name] = this.toPure(ruleInfo[name]));

                    if (!ruleInfo.docTypeCd) {
                        this.$swal({type: 'warning', text: '문서유형을 선택해 주세요.'});
                        return false;
                    }
                    if (!ruleInfo.useYn) {
                        this.$swal({type: 'warning', text: '사용여부를 선택해 주세요.'});
                        return false;
                    }
                    if (!ruleInfo.apprTypeCd) {
                        this.$swal({type: 'warning', text: '결재유형을 선택해 주세요.'});
                        return false;
                    }
                    if (!ruleInfo.fixYn) {
                        this.$swal({type: 'warning', text: '고정여부를 선택해 주세요.'});
                        return false;
                    }

                    const obj = this.aprverClassTypes.find(x => x.detailCd === ruleInfo.aprverClassCd);
                    if(obj) {
                        if (obj.remark1==='C') {
                            if (!ruleInfo.aprverClassVal) {
                                this.$swal({type: 'warning', text: '결재자구분값을 입력해 주세요.'});
                                return false;
                            }
                        }
                    }
                    return true;
                },
                doReturnObject(rId) {
                    this.returnObject.name = '';
                    this.$parent.$emit('receive', this.returnObject);
                    this.closeModal();
                },
                closeModal() {
                    this.$parent.close();
                },
            }
        ,
        mounted() {
            this.getDocTypeCombo();
            this.getApprTypeCombo();
            this.geAprverClassTypeCombo();

            if(this.hiddenCheck === 'Y') {
                this.form.docTypeNm = this.docTypeNm;
                this.form.docTypeCd = this.docTypeCd;
                this.form.useYn = this.useYn;
                this.form.ruleSeq = this.ruleSeq;
                this.form.apprTypeNm = this.apprTypeNm;
                this.form.apprTypeCd = this.apprTypeCd;
                this.form.fixYn = this.fixYn;
                this.form.aprverClassNm = this.aprverClassNm;
                this.form.aprverClassVal = this.aprverClassVal;
                this.form.aprverClassCd = this.aprverClassCd;
                this.form.remark = this.remark;
            }
        },
    }
</script>

<style scoped>
    div#gridbox {
        width: 100%;
        height: 100%;
        min-height: 300px;
    }

    .desc-content:after {
        clear: both;
        content: '';
        display: block;
    }

    .btn-wrap {
        margin-bottom: 20px;
    }

    .desc-content {
        border: 2px solid #9db6c9;
        background: #f9fafc;
        margin: 0 0 20px 0;
        border-radius: 4px;
        padding: 15px 2%;
        clear: both;
    }

    .desc-content .item {
        float: left;
    }

    .desc-content .item .desc-item {
        position: relative;
        padding-left: 82px;
        margin-bottom: 8px;
    }

    .desc-content .item .desc-item:last-child {
        margin-bottom: 0;
        height: 25px;
    }

    .desc-content .item .desc-item .tit {
        position: absolute;
        left: 0;
    }

    .desc-content .item .desc-item .label-tit {
        font-family: 'NotoM';
        color: #222;
        font-size: 15px;
    }

    .desc-content .item.desc-left .desc-item {
        padding-left: 90px;
    }

    .desc-content .item.desc-left .desc-item .desc:after {
        clear: both;
        content: '';
        display: block;
    }

    .desc-content .item.desc-left .desc-item .desc .datepicker {
        float: left;
    }

    .desc-content .item.desc-left .desc-item .desc span.wave {
        float: left;
        padding: 0 6px;
    }

    .desc-content .item.desc-left .desc-item .td-s-thumb.search-area:after {
        clear: both;
        content: '';
        display: block;
    }

    .desc-content .item.desc-left .desc-item .td-s-thumb.search-area input,
    .desc-content .item.desc-left .desc-item .td-s-thumb.search-area .ip-box {
        float: left;
    }

    .desc-content .item.desc-left .desc-item .desc.select select {
        width: 70%;
    }

    .desc-content .item.desc-left {
        width: 35%;
        padding-right: 40px;
    }

    .desc-content .item.desc-center {
        width: 35%;
        padding-right: 40px;
    }

    .desc-content .item.desc-right {
        width: 30%;
    }

    .search-area input {
        position: relative;
    }

    .search-area .icon {
        position: absolute;
        right: 8px;
        top: 1px;
        z-index: 100;
        cursor: pointer;
        font-size: 16px;
        color: #555;
    }

    .search-border .td-s-thumb {
        position: relative;
        display: inline-block;
    }

    .search-border .td-s-thumb.search-area > input,
    .search-border .td-s-thumb.search-area > .ip-box
    .search-border .td-s-thumb.search-area > button {
        float: left;
    }

    .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
        width: 60%;
        margin-left: 6px;
    }

    .remove_text {
        margin-left: 0;
    }

    .contents div.gridbox_material.gridbox .xhdr {
        border-bottom: 1px solid #dfdfdf;
    }

    @media (max-width: 1580px) {
        .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
            width: 50%;
        }
    }

      .modal-card {
          width: auto;
      }

    .tp-a {
        padding-left: 23px;
    }
    .tp-c {
        padding-left: 23px;
    }

    .table-area .table-a table th.tp-a:before {
        content: '*';
        color: #f04f2f;
        position: absolute;
        left: 11px;
        top: 16px;
    }
</style>
